import { create } from 'zustand'
import { persist, subscribeWithSelector } from 'zustand/middleware';
import { signOut } from 'firebase/auth';
import { auth } from '../Auth';
import {  customStorage, encryptData, load, store } from '../foo';
import { checkUserSubscriptionStatusFromDB, logMe } from '../../foo/user';

interface UserState {
    version: number;
    isUserStoreInitialized: boolean;
    userUniqueId: string | null;
    userEmail: string | null;
    checkoutSessionOK: boolean | null;
    subTkn: string | null;
    isSubscribed: boolean | null;
    updateIsSubscribedFromDB: () => Promise<void>;
    initUserStore: () => Promise<void>;
    hasLoggedIn: boolean;
    handleLogout: () => void;
    generateToken: () => Promise<string>;
    validateToken: () => Promise<boolean>;
    doLogin: (uuid: string, email: string | undefined) => void;
}


export const useUserStore = create<UserState>()(
    subscribeWithSelector(
        persist(
            (set, get) => ({
                version: 1,
                isUserStoreInitialized: false,
                userUniqueId: null,
                userEmail: null,
                checkoutSessionOK: null,
                subTkn: null,
                isSubscribed: null,
                hasLoggedIn: false,

                doLogin: async (uuid: string, email: string | undefined) => {
                    let isSubscribed = false;
                    if (email) {
                        isSubscribed = await checkUserSubscriptionStatusFromDB(email);
                    }
                    set({ userUniqueId: uuid, userEmail: email, hasLoggedIn: true, isSubscribed: isSubscribed });
                },

                generateToken: async () => {
                    const uuid = get().userUniqueId;
                    return uuid ? await encryptData("subTkn", uuid + "uid") : "";
                },

                validateToken: async () => {
                    const token = get().subTkn;
                    const uuid = get().userUniqueId;
                    if (token && uuid) {
                        const expectedToken = await encryptData("subTkn", uuid + "uid");
                        return token === expectedToken;
                    }
                    return false;
                },

                updateIsSubscribedFromDB: async () => {
                    const email = get().userEmail;
                    if (email) {
                        const isSubscribed = await checkUserSubscriptionStatusFromDB(email);
                        const token = isSubscribed ? await get().generateToken() : null;
                        set({ isSubscribed, subTkn: token });
                    }
                },

                initUserStore: async () => {
                    //await get().migrate();
                    await get().updateIsSubscribedFromDB();
                    set({ isUserStoreInitialized: true });
                },

                handleLogout: () => {
                    logMe("click_logout", {});
                    signOut(auth);
                    set({
                        userUniqueId: null,
                        userEmail: null,
                        isSubscribed: null,
                        hasLoggedIn: false,
                        subTkn: null,
                    });
                }
            }),
            {
                name: "userState",
                storage: customStorage,
                
                onRehydrateStorage: () => async (state, error) => {
                    if (state) {
                        await state.initUserStore();
                    }
                }
            }
        )
    )
);

